<template>
  <div id="task" class="task">
    <div v-if="selected == 'task'">
      <rise-loader color="rgb(39, 139, 172)" v-if="syllabuses.length == 0"></rise-loader>
      <div v-if="syllabuses.length != 0">
        <div style="margin-left: 20px;margin-right: 20px;margin-bottom: 20px;margin-top:-30px">
          <b-row align-h="between" class="justify-content-center align-items-center">
            <b-col cols="2"><b-btn v-on:click="switchComponent('list', fullTask)">&laquo; {{$t('task.back')}}</b-btn></b-col>
            <b-col cols="7">
              <b-row class="justify-content-center align-items-center">
                <b-col md="auto"><h1>{{fullTask.headline}} ({{fullTask.timelineDate  | moment("YYYY-MM-DD")}})</h1></b-col>
                <b-col md="auto" cols="1"><a :href="groupLink" target="_blank" class="cursor-pointer"><i class="fa fa-external-link"></i></a></b-col>
              </b-row>
            </b-col>
            <b-col cols="2">
              <b-btn v-on:click="switchComponent('evaluation', fullTask)" class="mx-1 float-right">{{$t('tack.forward')}} &raquo;</b-btn>
            </b-col>
          </b-row>
        </div>
        <b-nav tabs>
          <b-nav-item v-for='course in courses' v-bind:active="course.id == activeCourse.id" v-on:click="selectCourse(course)">{{course.code}}</b-nav-item>
        </b-nav>
      </div>
      <div v-for='syllabus in syllabuses'>
        <b-card border-variant="success" v-if="syllabus.code == activeCourse.code && syllabus.centralContents.length != 0">
          <b-container v-if="syllabus.centralContents.length != 0">
            <b-row @click="syllabus.ccCollapsed = !syllabus.ccCollapsed">
              <b-col cols="auto" v-if="!syllabus.ccCollapsed"><span><i class="fa fa-chevron-right cursor-pointer"></i></span></b-col>
              <b-col cols="auto" v-if="syllabus.ccCollapsed"><span><i class="fa fa-chevron-down cursor-pointer"></i></span></b-col>
              <b-col style="margin-bottom: 10px;" class="cursor-pointer">{{$t('tack.central.content')}}
                <span><i id="cc" class="fa fa-info-circle" v-b-tooltip.hover></i></span>
                <b-tooltip target="cc">
                  <span>{{$t('tack.central.content.info')}}</span>
                </b-tooltip>
              </b-col>
            </b-row>
            <b-row>
              <b-col v-if="!syllabus.ccCollapsed">
                  <span v-for="centralContent in syllabus.centralContents" class="central-content-section">
                    <b-button v-on:click="toggleParagraphActivity(fullTask, centralContentText)" class="goal" v-b-tooltip.hover :title='centralContentText.text' v-for='centralContentText in centralContent.paragraphs' size="lg" v-bind:variant="isCCSelected(centralContentText)"></b-button>
                  </span>
              </b-col>
            </b-row>
          </b-container>
          <b-collapse class="mt-2" v-model="syllabus.ccCollapsed" id="collapse4">
            <b-list-group class="list-group icon-block" v-for='centralContent in syllabus.centralContents'>
              <b-list-group-item v-for='centralContentText in centralContent.paragraphs' class="cursor-pointer" v-bind:variant="isCCSelected(centralContentText)" v-on:click="toggleParagraphActivity(fullTask, centralContentText)">
                <span v-html="centralContentText.text"></span>
              </b-list-group-item>
            </b-list-group>
          </b-collapse>
        </b-card>
        <b-card style="margin-top:10px" border-variant="success" v-if="syllabus.code == activeCourse.code">
          <b-container>
            <b-row @click="syllabus.goalCollapsed = !syllabus.goalCollapsed" >
              <b-col cols="auto" v-if="!syllabus.goalCollapsed"><span><i class="fa fa-chevron-right cursor-pointer"></i></span></b-col>
              <b-col cols="auto" v-if="syllabus.goalCollapsed"><span><i class="fa fa-chevron-down cursor-pointer"></i></span></b-col>
              <b-col style="margin-bottom: 10px;" class="cursor-pointer">{{$t('tack.goals')}}
                <span><i id="goals" class="fa fa-info-circle" v-b-tooltip.hover></i></span>
                <b-tooltip target="goals">
                  <span>{{$t('tack.goals.info')}}</span>
                </b-tooltip>
              </b-col>
            </b-row>
            <b-row>
              <b-col v-if="!syllabus.goalCollapsed">
                  <span v-for='groupSyllabus, nameSyllabus in syllabus.syllabusGrouped' class="central-content-section">
                    <b-button :id="goal.id" v-on:click="toggleGoalActivity(fullTask, goal)" class="goal" v-for='goal in groupSyllabus' size="lg" v-bind:variant="isGoalSelected(goal)"></b-button>
                    <b-tooltip :target="goal.id" v-for='goal in syllabus.goals' placement="top">
                      <span v-html="goal.text"></span>
                    </b-tooltip>
                  </span>
              </b-col>
            </b-row>
          </b-container>
          <b-collapse class="mt-2" v-model="syllabus.goalCollapsed" id="collapse4">
            <b-list-group class="list-group icon-block" id='listGroup' v-for='groupSyllabus, nameSyllabus in syllabus.syllabusGrouped'>
              <b-list-group-item v-for='goal in groupSyllabus' class="cursor-pointer" v-bind:variant="isGoalSelected(goal)" v-on:click="toggleGoalActivity(fullTask, goal)"><span v-html="goal.text"></span></b-list-group-item>
            </b-list-group>
          </b-collapse>
        </b-card>
      </div>
    </div>
    <error-modal @closeModal="closeModal" v-bind:text="errorText" v-bind:errorModalShow="errorModalShow"></error-modal>
    <div v-if="selected == 'evaluation'">
      <evaluation v-bind:task=fullTask v-bind:market=market v-bind:learnUrl=learnUrl @clicked="switchComponent('task')"></evaluation>
    </div>
  </div>
</template>

<script>
import { RiseLoader } from 'vue-spinner/dist/vue-spinner.min.js'
import api from '../api'
import Evaluation from './Evaluation'
import ErrorModal from './ErrorModal'

export default {
  components: {
    RiseLoader, Evaluation, ErrorModal
  },
  name: 'Task',
  props: ['task', 'group', 'market', 'learnUrl'],
  data () {
    return {
      fullTask: null,
      courses: [],
      activeCourse: null,
      syllabuses: [],
      selected: 'task',
      selectedGoal: null,
      groupLink: null,
      errorText: '',
      errorModalShow: false
    }
  },
  created () {
    api.fetchTask(this.task.id).then(response => {
      if (response.error) {
        this.showError(response.error)
        return
      }

      this.fullTask = response
      this.groupLink = this.learnUrl + response.groupLink
      for (var i in this.fullTask.courses) {
        api.fetchCourse(this.fullTask.id, this.fullTask.courses[i].id).then(response => {
          if (response.error) {
            this.showError(response.error)
            return
          }
          if (!this.activeCourse) {
            this.activeCourse = response
          }
          this.courses.push(response)

          api.fetchSyllabus(response.syllabusId).then(response => {
            if (response.error) {
              this.showError(response.error)
              return
            }
            response.centralContents = this.filterCentralContents(response.centralContents, this.group.groupYear)
            response.goals = this.filterSyllabusGoals(response.goals, this.group.groupYear)
            response.syllabusGrouped = groupBy(response.goals, 'p')
            this.syllabuses.push(response)
          })
        })
      }
    })

    function groupBy (array, key) {
      const result = {}
      array.forEach(item => {
        if (!result[item[key]]) {
          result[item[key]] = []
        }
        result[item[key]].push(item)
      })
      return result
    }
  },
  methods: {
    switchComponent: function (comp, task) {
      if (comp === 'list') {
        this.$emit('clicked', comp)
      } else {
        this.selected = comp
      }
    },

    isGoalSelected: function (goal) {
      for (var i in this.activeCourse.goals) {
        if (this.activeCourse.goals[i].goal.id === goal.id) {
          return 'success'
        }
      }
      return 'outline-success'
    },

    isCCSelected: function (centralContent) {
      for (var i in this.activeCourse.centralContents) {
        if (this.activeCourse.centralContents[i].id === centralContent.id) {
          return 'success'
        }
      }
      return 'outline-success'
    },

    selectCourse: function (course) {
      this.activeCourse = course
    },

    toggleGoalActivity: function (activity, goal, course) {
      if (activity.taskConnected) {
        return
      }

      if (!course) {
        course = this.activeCourse
      }
      var goalIndex
      for (var j in course.goals) {
        var goalSelected = course.goals[j].goal ? course.goals[j].goal : course.goals[j]
        if (goalSelected.id === goal.id) {
          goalIndex = j
          break
        }
      }

      if (goalIndex) {
        api.deleteGoal(activity, course, goal).then(response => {
          if (response.error) {
            this.showError(response.error)
            return
          }
          course.goals.splice(goalIndex, 1)
        })
      } else {
        api.addGoal(activity, course, goal).then(response => {
          if (response.error) {
            this.showError(response.error)
            return
          }
          course.goals.push({goal: goal})
        })
      }
    },

    toggleParagraphActivity: function (activity, paragraph, course) {
      if (!course) {
        course = this.activeCourse
      }
      var paragraphIndex
      if (paragraph.type === 'SUBJ_CC_PARAGRAPH') {
        for (var j in course.centralContents) {
          if (course.centralContents[j].id === paragraph.id) {
            paragraphIndex = j
            break
          }
        }
      }

      if (paragraphIndex) {
        this.removeParagraph(activity, course, paragraph, paragraphIndex)
      } else {
        this.addParagraph(activity, course, paragraph)
      }
    },

    addParagraph: function (activity, course, paragraph) {
      api.addParagraph(activity.id, course.id, paragraph.id).then(function (response) {
        if (response && response.error) {
          this.showError(response.error)
          return
        }
        if (paragraph.type === 'SUBJ_CC_PARAGRAPH') {
          if (course.centralContents == null) {
            course.centralContents = []
          }
          course.centralContents.push(paragraph)
        }
      })
    },

    removeParagraph: function (activity, course, paragraph, paragraphIndex) {
      api.removeParagraph(activity.id, course.id, paragraph.id).then(function (response) {
        if (response && response.error) {
          this.showError(response.error)
          return
        }
        if (paragraph.type === 'SUBJ_CC_PARAGRAPH') {
          course.centralContents.splice(paragraphIndex, 1)
        }
      })
    },

    filterSyllabusGoals: function (courseGoals, yeargroup) {
      var filteredGoals = []
      for (var i in courseGoals) {
        if (courseGoals[i].p !== -1 && (courseGoals[i].yeargroup === null || courseGoals[i].yeargroup === yeargroup)) {
          filteredGoals.push(courseGoals[i])
        }
      }
      return filteredGoals
    },

    filterCentralContents: function (centralContents, yeargroup) {
      var filteredCC = []
      for (var i in centralContents) {
        if (centralContents[i].yeargroup === null || centralContents[i].yeargroup === yeargroup) {
          filteredCC.push(centralContents[i])
        }
      }
      return filteredCC
    },

    showError: function (text) {
      this.errorText = text
      this.errorModalShow = true
    },

    closeModal: function (variable) {
      this.errorModalShow = variable
    }
  }
}
</script>

<style scoped>
  .goal {
    height: 28px;
    width: 30px;
    font-weight: 400;
    border: 1px solid #ccc;
    margin: 2px !important;
    padding: 1px;
  }

  .cursor-pointer {
    cursor: pointer;
  }

  .central-content-section:not(:empty) {
    padding-right: 20px;
  }

  .icon-block {
    margin-bottom: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Task.vue